<div
  #trapContainer
  class="p-2"
  style="min-width: min(20vw, min-content);"
  role="presentation"
>
  <ng-template #dynamicComponentContainer></ng-template>
</div>
